import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import apiRequests from '../api-helpers/ApiRequests'
import { FormattedInput } from "@buttercup/react-formatted-input";
import Select from 'react-select';
import ReactCountryFlag from "react-country-flag";
import CountryCodes from 'country-calling-code';
import PhoneNumber from 'libphonenumber-js';
import { useTranslation } from 'react-i18next';
class ModalDrivers extends Component {

	constructor(props) {
		super(props);

		this.state = {
			NewItem: { Nationality: "1" },
			customOrder: ['PL', 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'BY', 'UA', 'MD', 'TR', 'RS', 'BA', 'MK', 'ME', 'AL', 'XK', 'KZ', 'UZ', 'TM', 'KG', 'TJ', 'GE', 'AM', 'AZ', 'RU', 'NO', 'CH'],
			phoneNumber:  '+48',
			customOrderItems: [],
			countriesList: [],
			countryIndex: 0,
			selectedCountry: null,
			selectedItem: '',
			isValidPhoneNumber: false,
			errors: "",
			isValidForm: true,
			prevShowModal: true,
			labelValues: {
				editDriver: {
					title: this.props.t('drivers.addDriver'),
					sendButton: this.props.t('common.edit')
				},
				addDriver: {
					title: this.props.t('drivers.newDriver'),
					sendButton: this.props.t('common.add')
				}
			}
		}

		this.hideModal = this.hideModal.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
		this.onFormSubmit = this.onFormSubmit.bind(this);
		this.newItemCallback = this.newItemCallback.bind(this);

		this.phoneRef = React.createRef();

		this.addDriver = this.addDriver.bind(this);
		this.editDriver = this.editDriver.bind(this);
		this.editDriverCallback = this.editDriverCallback.bind(this);

		//this.getCountryCodeFromPhoneNumber = this.getCountryCodeFromPhoneNumber.bind(this);
	}


	sendDataToParent = (data, eventName) => {
    this.props.backToParrentData(data, eventName);
  }

	onInputChange(event) {
		this.setState((prevState) => ({ NewItem: { ...prevState.NewItem, [event.target.name]: event.target.value } }), () => {

			//callback check data isValid on server side, after invalidate submit
			if (!this.state.isValidForm)
				apiRequests.getDataByUrlWithParam('webconapi/AddNewDriverValidate', this.state.NewItem, this.newItemCallback);

		});
	}

	addDriver() {
		let newItem = this.state.NewItem;
		if (newItem) {
			newItem.CompanyWorkflowId = this.props.userData.CompanyWorkflowId + "";
			newItem.AccountWorkflowId = this.props.userData.AccountWorkflowId + "";
			apiRequests.getDataByUrlWithParam('webconapi/AddNewDriver', newItem, this.newItemCallback);
		}
	}

	newItemCallback(data, response) {
		if (response.status == 400) {
			if (data.errors) {
				this.setState({
					isValidForm: false,
					errors: data.errors
				});
			}
		}

		else if (response.status == 200) {
			if (data.Message && data.Message == "ok") {
				this.sendDataToParent(data, 'addDriver');
				this.hideModal();
			}
			else if (data.Message && data.Message == "exist") {
				this.setState({
					isValidForm: false,
					errors: { IdDocumentNumber: ['Kierowca o podanym numerze dokumentu został już dodany do systemu.'] }
				});
			}
			else {
				this.setState({
					errors: "",
				});
			}
		}

		this.props.addNewEventNotificationCallback();
	}

	editDriver() {

	  let elemId = this.props.selectedItem.cells[0].value;

		if (typeof elemId !== 'undefined') {

			let national = JSON.stringify([{
				"Id": this.props.selectedItem.cells[3].value[0].id, 
				"Name": this.props.selectedItem.cells[3].value[0].name 
			}]);
			let editDriverParams = {
				Id: this.props.selectedItem.id,
				Name: this.state.NewItem.Name ? this.state.NewItem.Name : this.props.selectedItem.cells[1].value,
				Surname: this.state.NewItem.Surname ? this.state.NewItem.Surname : this.props.selectedItem.cells[2].value,
				Nationality: national,
				IdDocumentNumber: this.props.selectedItem.cells[4].value,
				Address: this.state.NewItem.Address ? this.state.NewItem.Address : this.props.selectedItem.cells[5].value,
				ZipCode: this.state.NewItem.Postcode ? this.state.NewItem.Postcode : this.props.selectedItem.cells[6].value,
				City: this.state.NewItem.City ? this.state.NewItem.City : this.props.selectedItem.cells[7].value,
				Phone: this.state.NewItem.Phone ? this.state.NewItem.Phone : this.props.selectedItem.cells[8].value,
				isActivated: 1,
			}

			apiRequests.getDataByUrlWithParam('webconapi/EditDriverDictionaryItem', editDriverParams, this.editDriverCallback);

		}
	}

	editDriverCallback(data, response) {
		this.sendDataToParent(data, 'EditDriver');
	}

	onFormSubmit(event) {
		

		if( this.props.formEvent == "addDriver" ) {

			this.addDriver();


		} else if( this.props.formEvent == "editDriver" ) {
			this.editDriver();
		}

		event.preventDefault();
	}

	setCountriesList( phoneIndex ) {
		const { customOrder } = this.state;
		const customOrderItems = [];
		const countriesList = Object.keys(CountryCodes)
			.map((countryCode, index) => {
				const countryData = CountryCodes[countryCode];

				if (customOrder.includes(countryData.isoCode2)) {
					if ( countryData.isoCode2 == customOrder[phoneIndex] && this.props.formEvent == "editDriver" ) {
						this.setState({ phoneNumber: this.props.selectedItem.cells && this.props.formEvent == "editDriver" ? this.props.selectedItem.cells[8].value : `+${countryData.countryCodes[0]}`  });
					}
					const customOrderItem = {
						code: countryData.isoCode2,
						label: (
							<span>
								<ReactCountryFlag countryCode={countryData.isoCode2} svg /> {countryData.country}
							</span>
						),
						value: `+${countryData.countryCodes[0]}`,
					};
					customOrderItems.push(customOrderItem);
				}
				return {
					code: countryData.isoCode2,
					label: (
						<span>
							<ReactCountryFlag countryCode={countryData.isoCode2} svg /> {countryData.country}
						</span>
					),
					value: `+${countryData.countryCodes[0]}`,
				};
			})
			.filter((country) => !customOrder.includes(country.code));

		// Reorder customOrderItems based on customOrder array
		const reorderedCustomOrderItems = customOrder.map((code) =>
			customOrderItems.find((item) => item.code === code)
		);

		this.setState({
			customOrderItems: reorderedCustomOrderItems,
			countriesList,
		});
	}

	componentDidMount() {
		this.setCountriesList( 0 );
	}

	componentDidUpdate(prevProps, prevState) {
		if( prevProps.showModal !== this.props.showModal ) {
			this.setState({ prevShowModal: prevProps.showModal });
		}	
	};

	handlePhoneTextChange = (event) => {
		const selCountryVal = this.state.selectedCountry ? this.state.selectedCountry : null;
		const { value } = event.target;
		this.setState({ phoneNumber: selCountryVal && value.length <= selCountryVal.value.length ? (`${selCountryVal.value }`) : value });
		this.onInputChange(event);

	};

	handleCountryChange = (selectedCountry) => {
		this.setState({ phoneNumber: '' });
		this.setState({ selectedCountry }, () => {
			const { selectedCountry, phoneNumber } = this.state;
			if (selectedCountry) {
				const countryCode = selectedCountry.value;
				this.setState({ phoneNumber: `${countryCode}`, countryIndex: this.state.customOrder.indexOf( countryCode ) }, () => {});
				this.setCountriesList( this.state.customOrder.indexOf( countryCode ) );
			}
		});
	};

	hideModal() {
		this.setState({ 
			NewItem: { Nationality: "1" }, 
			errors: "", 
			isValidForm: true,
			phoneNumber: '+48', 
			countryIndex: 0,
			prevShowModal: true
		});
		this.props.onChangeEditItemFormVisibilityHandler(false);
	}

	showModal( propsShow ) {

		if( propsShow == true && this.props.formEvent == "editDriver" ) {
			// Update countries select if selected user phone from amother country
			const parsedNumber = PhoneNumber(this.props.selectedItem.cells[8].value);
			let index = parsedNumber ? this.state.customOrder.indexOf( parsedNumber.country ) : 0;

			if(this.props.selectedItem.cells[8].value !== this.state.phoneNumber && this.state.prevShowModal !== false  ) {
				this.setState({ 
					phoneNumber: this.props.selectedItem.cells[8].value,
					selectedCountry: parsedNumber ? { code: parsedNumber.country, label: '', value: `+${parsedNumber.countryCallingCode}` } : { code: 'PL', label: '', value: `+48` }, 
					countryIndex: index
				});
				this.setCountriesList( index );
			}
		}
		return propsShow;
	
	}

	render() {

		const { phoneNumber, customOrderItems } = this.state;

		const a = this.state.NewItem.Nationality == "1";

		const ZipCodePattern = [
			{ char: /\d/, repeat: 2 },
			{ exactly: "-" },
			{ char: /\d/, repeat: 3 },
		];

		return (
			<>
				<Modal 
					show={ this.showModal( this.props.showModal ) } 
					onHide={this.hideModal}
				>
					<Modal.Header closeButton>
						<Modal.Title>{ this.props.formEvent == "editDriver" ? this.state.labelValues.editDriver.title : this.state.labelValues.addDriver.title }</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<form id="new-ev-not-form" onSubmit={this.onFormSubmit} className="form-font">
							<div className="mb-3">
								<label htmlFor="name" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('notification.notifySingle.nameLabel')}</label>
								<input 
									type="text" 
									className="form-control" 
									defaultValue={ this.props.formEvent == "editDriver" && this.props.selectedItem.cells ? this.props.selectedItem.cells[1].value : '' } 
									id="name" 
									name="Name" 
									onChange={this.onInputChange}
								/>
								<span className="text-danger">{this.state.errors.Name ? this.state.errors.Name[0] : ""}</span>
							</div>
							<div className="mb-3">
								<label htmlFor="surname" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('notification.notifySingle.surnameLabel')}</label>
								<input 
									type="text" 
									className="form-control" 
									id="surname" 
									name="Surname" 
									onChange={this.onInputChange} 
									defaultValue={ this.props.formEvent == "editDriver" && this.props.selectedItem.cells ? this.props.selectedItem.cells[2].value : '' } 
								/>
								<span className="text-danger">{this.state.errors.Surname ? this.state.errors.Surname[0] : ""}</span>
							</div>
							<div className="mb-3">
								<label htmlFor="nationality" className="form-label m-0 p-0">{this.props.t('notification.notifySingle.nationalityLabel')}</label>
								<select 
									className="form-select" 
									name="Nationality" 
									id="nationality"
									aria-label="Wybierz..." 
									onChange={this.onInputChange}
								>
									<option 
										value="1" 
										selected={ this.props.formEvent == "editDriver" && this.props.selectedItem.cells && this.props.selectedItem.cells[3].value[0].name == 'obywatel PL' ?  true : false } 
									>
										{this.props.t('notification.notifySingle.nationalityPl')}
									</option>
									<option 
										value="2"
										selected={ this.props.formEvent == "editDriver" && this.props.selectedItem.cells && this.props.selectedItem.cells[3].value[0].name == 'cudzoziemiec' ?  true : false } 
									>
										{this.props.t('notification.notifySingle.nationalityForeign')}
									</option>
								</select>
								<span className="text-danger">{this.state.errors.Nationality ? this.state.errors.Nationality[0] : ""}</span>
							</div>
							<div className={"mb-3 " + (this.state.NewItem.Nationality == "1" ? "d-none" : "d-none")} >
								<label htmlFor="pesel" className="form-label m-0 p-0">PESEL</label>
								<input 
									type="text"
									className="form-control"
									id="pesel"
									name="PESEL"
									onChange={this.onInputChange} 
									defaultValue={ this.props.formEvent == "editDriver" && this.props.selectedItem.cells ? this.props.selectedItem.cells[4].value : '' } 
									readOnly={ this.props.formEvent == "editDriver" ? true : false }
								/>
								<span className="text-danger">{this.state.errors.PESEL ? this.state.errors.PESEL[0] : ""}</span>
							</div>
							<div className={"mb-3 " + (this.state.NewItem.Nationality == "1" ? "" : "")}>
								<label htmlFor="idDocumentNumber" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('notification.notifySingle.documentLabel')}</label>
								<input 
									type="text" 
									className="form-control" 
									id="idDocumentNumber" 
									name="IdDocumentNumber" 
									onChange={this.onInputChange} 
									defaultValue={ this.props.formEvent == "editDriver" && this.props.selectedItem.cells ? this.props.selectedItem.cells[4].value : '' } 
									readOnly={ this.props.formEvent == "editDriver" ? true : false }

								/>
								<span className="text-danger">{this.state.errors.IdDocumentNumber ? this.state.errors.IdDocumentNumber[0] : ""}</span>
							</div>
							<div className="mb-3">
								<label htmlFor="address" className="form-label m-0 p-0">{this.props.t('notification.notifySingle.addressLabel')}</label>
								<input 
									type="text"
									className="form-control"
									id="address"
									name="Address"
									onChange={this.onInputChange}
									defaultValue={this.props.formEvent == "editDriver" && this.props.selectedItem.cells ? this.props.selectedItem.cells[5].value : ''}
									placeholder={this.props.t('notification.notifySingle.addressPlaceholder')}
								/>
								<span className="text-danger">{this.state.errors.Address ? this.state.errors.Address[0] : ""}</span>
							</div>
							<div className="mb-3">	
								<label htmlFor="zipCode" className="form-label m-0 p-0">{this.props.t('notification.notifySingle.zipLabel')}</label>
								<FormattedInput
									id="zipCode"
									name="ZipCode"
									className="form-control"
									format={ZipCodePattern}
									onChange={(formattedValue, raw) => {
										const event =
										{
											target: {
												value: formattedValue,
												name: "ZipCode"
											}
										}
										this.onInputChange(event)
									}}
									defaultValue={ this.props.formEvent == "editDriver" && this.props.selectedItem.cells ? this.props.selectedItem.cells[6].value : '' } 
									placeholder="np. 12-345"
								/>
								<span className="text-danger">{this.state.errors.ZipCode ? this.state.errors.ZipCode[0] : ""}</span>
							</div>
							<div className="mb-3">
								<label htmlFor="city" className="form-label m-0 p-0">{this.props.t('notification.notifySingle.cityLabel')}</label>
								<input 
									type="text" 
									className="form-control" 
									id="city" 
									name="City" 
									onChange={this.onInputChange} 
									defaultValue={ this.props.formEvent == "editDriver" && this.props.selectedItem.cells ? this.props.selectedItem.cells[7].value : '' } 
								/>
								<span className="text-danger">{this.state.errors.City ? this.state.errors.City[0] : ""}</span>
							</div>
							<div className="input-group mb-3">
								<label htmlFor="phone" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('notification.notifySingle.phoneLabel')}</label>
								<div className="input-group phone-input-group">
									<Select
										options={customOrderItems}
										value={customOrderItems[this.state.countryIndex]}
										onChange={this.handleCountryChange}
										placeholder="Select a country"
										isSearchable={false}
									/>
									<input
										type="tel"
										pattern="\+\d*"
										className="form-control"
										id="phone"
										name="Phone"
										//defaultValue={ this.props.selectedItem.cells ? this.props.selectedItem.cells[8].value : phoneNumber } 
										value={ this.state.phoneNumber }
										onChange={ this.handlePhoneTextChange }
									/>
								</div>
								<span className="text-danger">{this.state.errors.Phone ? this.state.errors.Phone[0] : ""}</span>
								{ this.props.formEvent == "addDriver" ? (
									<span className="text-danger lh-6">{this.props.t('notification.notifySingle.phoneNote')}</span>
									) : '' }
							</div>
						</form>
					</Modal.Body>
					<Modal.Footer>
						<button form="new-ev-not-form" type="submit" className="btn btn-primary">
							{ this.props.formEvent == "editDriver" ? this.state.labelValues.editDriver.sendButton : this.state.labelValues.addDriver.sendButton }
						</button>
						<Button variant="secondary" onClick={this.hideModal}>
							{this.props.t('common.close')}
						</Button>
					</Modal.Footer>
				</Modal>
			</>
		)
	}
}

function withMyHook(Component) {
	return function WrappedComponent(props) {
		const { t } = useTranslation();
		return <Component {...props} t={t} />;
	};
}

export default withMyHook(ModalDrivers);